import React from "react";
import { defaultIConfig, IChat, IConfig, IProject, IUser } from "@/lib/types";

export interface IUserContext {
    user: IUser | undefined;
    updateUser: (user: IUser | undefined) => void;
}

export const UserContext = React.createContext<IUserContext>({
    user: undefined,
    updateUser: () => {
        return;
    },
});

export interface IApiError {
    message: string;
    type: "cors" | "network" | "auth" | "api" | "unknown";
    details?: string;
    timestamp: number;
}

export interface IErrorContext {
    errors: IApiError[];
    addError: (error: IApiError) => void;
    clearError: (timestamp: number) => void;
    clearAllErrors: () => void;
}

export const ErrorContext = React.createContext<IErrorContext>({
    errors: [],
    addError: () => {
        return;
    },
    clearError: () => {
        return;
    },
    clearAllErrors: () => {
        return;
    },
});

export interface IChatsContext {
    chats: IChat[];
    setChats: React.Dispatch<React.SetStateAction<IChat[]>>;
    updateChat: (chat: Partial<IChat>, doNetwork: boolean, doUpdateTime?: boolean) => Promise<void>;
    deleteChat: (id: string) => Promise<void>;
}

export const ChatsContext = React.createContext<IChatsContext>({
    chats: [],
    setChats: () => {
        return;
    },
    updateChat: async () => {
        return;
    },
    deleteChat: async () => {
        return;
    },
});

export interface IProjectsContext {
    projects: IProject[];
    setProjects: (projects: IProject[]) => void;
    createProject: (project: Pick<IProject, "title" | "description">) => Promise<IProject>;
    updateProject: (project: Partial<IProject>) => Promise<void>;
    deleteProject: (id: string) => Promise<void>;
}

export const ProjectsContext = React.createContext<IProjectsContext>({
    projects: [],
    setProjects: () => {
        return;
    },
    createProject: async () => ({}) as IProject,
    updateProject: async () => {
        return;
    },
    deleteProject: async () => {
        return;
    },
});

export interface IConfigContext {
    config: IConfig;
    updateConfig: (config: IConfig) => void;
}

export const ConfigContext = React.createContext<IConfigContext>({
    config: defaultIConfig,
    updateConfig: () => {
        return;
    },
});
